module.exports = __webpack_public_path__ + "static/media/pores.3aa61b04.svg";